import { useNavigate } from "react-router-dom";
import { DonkeyMark } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-donkey-bg grain flex flex-col items-center justify-center px-5 text-center">
      <DonkeyMark size={64} className="mb-6 opacity-80" />
      <h1 className="font-heading font-bold text-2xl text-donkey-warm">No harm done.</h1>
      <p className="mt-3 text-donkey-grey max-w-md">
        Payment cancelled — you weren't charged. Your snapshot is still waiting whenever you're ready.
      </p>
      <div className="mt-8 flex gap-3">
        <Button onClick={() => navigate(-1)} className="bg-donkey-orange text-donkey-black font-semibold" data-testid="back-btn">
          Back to my report
        </Button>
        <Button onClick={() => navigate("/dashboard")} variant="outline" className="border-white/15 bg-transparent text-donkey-warm hover:bg-white/5">
          Dashboard
        </Button>
      </div>
    </div>
  );
}
